import { render } from "./textAndMediaBlock.vue?vue&type=template&id=04156dcb&scoped=true&ts=true"
import script from "./textAndMediaBlock.vue?vue&type=script&lang=ts"
export * from "./textAndMediaBlock.vue?vue&type=script&lang=ts"

import "./textAndMediaBlock.vue?vue&type=style&index=0&id=04156dcb&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04156dcb"]])

export default __exports__